/**
 * Tailwind CSS class name merge utility.
 * Combines clsx and tailwind-merge for conflict-free class merging.
 */
import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}
